import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const DetalleSolicitudApi = () => {
    const [cargando, setCargando] = useState(false);

    const getDetalleAnalisis = async (analisisId) => {
        try {
            setCargando(true);
            const response = await api.get(
                `laboratorio_produccion/detalle_analisis/${analisisId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarAnalisisDRC = async (analisis_id, data) => {
        try {
            setCargando(true);
            const response = await api.patch(
                `laboratorio_produccion/actualizar_analisis_drc/${analisis_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const guardarAnalisisDRC = async (analisis_id, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `laboratorio_produccion/guardar_datos_drc/${analisis_id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getDetalleAnalisis,

        actualizarAnalisisDRC,
        guardarAnalisisDRC,

        cargando,
    };
};
